import { Component, Input } from "@angular/core";

@Component({
    selector: "app-global-search-output",
    templateUrl: "./global-search-output.component.html",
    styleUrls: ["./global-search-output.component.scss"],
})
export class GlobalSearchOutputComponent {
    @Input() showRecentActions: boolean = false;
    selectedTab = "Orders";

    constructor(
    ) {}

    ngOnInit(): void {
    }
}
